import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Input } from '../../components/Form';
import Button from '../../components/Button';

import Wrapper from './WrapperOLD';

const SSOSignIn = ({ isLoading, message, onSubmit, onResetMessage }) => {
	const navigate = useNavigate();
	const [formState, setFormState] = useState({});
	const [error, setError] = useState(null);

	useEffect(() => {
		if (message) {
			onResetMessage();
		}
	}, []);

	const handleSubmit = ({ email }) => {
		if (email && email.includes('@')) {
			onSubmit({ email });
			navigate('/login');
		} else {
			setError({ type: 'error', value: 'Missing valid email' });
		}
	};

	return (
		<Wrapper title="Login with SSO" message={message || error}>
			<div className="space-y-6">
				<div>
					<label
						htmlFor="email"
						className="block text-sm font-medium text-gray-700"
					>
						Please enter your email address
					</label>
					<div className="mt-1">
						<Input
							id="email"
							name="email"
							type="email"
							autoComplete="email"
							autoFocus
							placeholder="Email"
							onChange={(e) =>
								setFormState({ ...formState, email: e.target.value })
							}
							value={formState.email}
						/>
					</div>
				</div>
				<div className="flex justify-between">
					<Button
						type="ghost"
						className="flex-shrink-0"
						onClick={() => navigate('/login')}
					>
						Go back
					</Button>
					<Button
						type="primary"
						className="flex-shrink-0"
						onClick={() => handleSubmit(formState)}
					>
						{isLoading ? 'Loading...' : 'Login with SSO'}
					</Button>
				</div>
			</div>
		</Wrapper>
	);
};

export default SSOSignIn;
